export default [
  'not interested',
  'fake',
  'invalid phone number',
  'phone number belongs to another user',
  'already solved',
  'does not requirements',
];
